import api from './client';

export interface PurviewClassification {
  name: string;
  count: number;
}

export interface PurviewDataSource {
  name: string;
  kind: string;
  id: string;
}

export interface PurviewStats {
  totalAssets: number;
  classifications: PurviewClassification[];
  dataSourceCount: number;
  dataSources: PurviewDataSource[];
  connectionName: string;
  endpoint: string;
}

export interface PurviewConnection {
  id: string;
  name: string;
  is_active: boolean;
  test_status?: 'success' | 'failed';
  last_tested_at?: string;
}

export async function getPurviewConnections(): Promise<PurviewConnection[]> {
  const res = await api.get('/api/purview/connections');
  return res.data.connections ?? [];
}

export async function getPurviewStats(connectionId?: string): Promise<PurviewStats> {
  const params = connectionId ? `?connectionId=${connectionId}` : '';
  const res = await api.get(`/api/purview/stats${params}`);
  return res.data;
}

export async function triggerPurviewScan(
  dataSourceName: string,
  connectionId: string,
  scanName?: string
): Promise<{ success: boolean; message: string; runId: string; scanName: string }> {
  const res = await api.post(`/api/purview/scan/${dataSourceName}`, { connectionId, scanName });
  return res.data;
}
